Customer.Dashboard ||= {}

class Customer.Dashboard.AutomaticRefreshView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/header/automatic_refresh']

  events:
    'click .checkbox-automatic-refresh': 'automaticRefreshChanged'

  initialize: (filter) ->
    @filter = filter
    @cookie_parser = new Cookie()
    cookies = @cookie_parser.parse(document.cookie)
    filter_id = @filter.id
    if cookies['filter_'+filter_id]
      @automaticRefresh = cookies['filter_'+filter_id] == 'true'
    else
      @automaticRefresh = true

  render: ->
    @$el.html(@template({automatic_refresh: @automaticRefresh}))
    this.$el.find('.checkbox-automatic-refresh')[0].checked = @automaticRefresh
    @

  automaticRefreshActive: =>
    @automaticRefresh

  automaticRefreshChanged: (event) =>
    @_keepCustomerSessionAlive()
    new_value = this.$el.find('.checkbox-automatic-refresh')[0].checked
    @automaticRefresh = new_value
    @addCookie()

  addCookie:->
    key = 'filter_'+@filter.id
    value = @automaticRefresh
    @cookie_parser.addCookie(key, value)

  show: ->
    @$el.find('.automatic-refresh').css('display', 'block')

  hide: ->
    @$el.find('.automatic-refresh').css('display', 'none')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
